import noticeStore from '@components/LocalMerchant/NoticeChat/store'
import { MARKETING_CENTER_PATH } from '@constant'
import { dGet } from '@core/utils'
import { HeaderView } from '@merchant-backend/common-components'
import { isPureUltimate, isStandard } from '@merchant-backend/util'
import { HLJ_STATISTIC, isTelSaleCityMerchant } from '@util'
import { toJS } from 'mobx'
import { inject, observer, Provider } from 'mobx-react'
import React, { Component } from 'react'
import { Link } from 'react-router'
import Header from './Header'
import style from './index.module.less'
import Pro from './Pro'
import Standard from './standard'
import Store from './store'
import ZunXiangPage from './ZunXiangPage'

@inject('pageStore')
@observer
class UltimateStandardPage extends Component {
  componentDidMount() {
    this.scroll.addEventListener('scroll', this.handleScroll)
    /* 是否为旗舰版 */
    if (isPureUltimate()) {
      HLJ_STATISTIC({
        element_tag: 'pro_page_view',
        event_type: 'element_view'
      })
    }
    /* 是否为标准版 */
    if (isStandard()) {
      HLJ_STATISTIC({
        element_tag: 'standard_page_view',
        event_type: 'element_view'
      })
    }
  }

  componentWillUnmount() {
    //移除的时候取消监听
    this.scroll.removeEventListener('scroll', this.handleScroll)
    noticeStore.setBottom()
  }

  handleScroll = e => {
    const scrollTop =
      dGet(e.srcElement, 'scrollTop') || dGet(e.target, 'scrollTop')
    const { showAffix } = this.props.pageStore
    if (scrollTop > 360 && !showAffix) {
      this.props.pageStore.setStoreData('showAffix', true)
    }
    if (scrollTop <= 360 && showAffix) {
      this.props.pageStore.setStoreData('showAffix', false)
    }
  }

  setScrollTop = (scrollTop = '0px') => {
    this.scroll.scrollTop = scrollTop
  }

  render() {
    const {
      pageStore: { type, purchaseData },
      ...rest
    } = this.props
    /* 不是四大并且不是婚宴酒店时显示显示旗舰版和标准版的tab */
    // const showProductTabs = !isSiDaProperty() && !isHotelProperty()
    return (
      <>
        <div
          className={style['scroll']}
          ref={scroll => {
            this.scroll = scroll
          }}
        >
          <Header {...rest} />

          {/* {showProductTabs && (
            <div className={style.center}>
              <Switch store={this.props.pageStore} type={type} />
            </div>
          )} */}
          {/* type=1时，页面正显示为旗舰版 */}
          {type == '1' ? (
            <Pro {...rest} purchaseData={purchaseData} />
          ) : (
            <Standard {...rest} />
          )}
        </div>
      </>
    )
  }
}

@observer
class IntroductionPage extends Component {
  render() {
    if (isTelSaleCityMerchant()) {
      /* 电销城市特有尊享版 */
      return <ZunXiangPage {...this.props} />
    }
    /* 最终标准页面 */
    return <UltimateStandardPage {...this.props} />
  }
}

@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.store.getDetail()
    this.store.getPurchaseData()
  }

  componentWillUnmount() {
    noticeStore.setBottom()
  }

  render() {
    const pay_money = toJS(this.store.pay_money)
    const coupon = toJS(this.store.coupon)
    const detail = toJS(this.store.detail)
    const { personal_ultimate_num } = this.store

    const props = {
      pay_money,
      coupon,
      detail,
      personal_ultimate_num,
      store: this.store
    }

    return (
      <Provider pageStore={this.store}>
        <HeaderView
          header={[
            <Link to={MARKETING_CENTER_PATH}>服务市场</Link>,
            '店铺产品'
          ]}
          title=""
          contentStyle={{
            padding: 0
          }}
        >
          <IntroductionPage {...props} />
        </HeaderView>
      </Provider>
    )
  }
}

export default Index
